import $ from 'jquery'
import {
    CardContainerClass, 
    showSpinner, 
    hideSpinner, 
    checkNoCards,
} from './module_common'
import { configBookCard } from './module_book_card'
import {updateCardLazyLoad} from './module_lazyload';

let filterCategories = [];

export let searchOrder = "";

export function setSearchOrder(order){
    searchOrder = order
}

export const defaultLimit = itemsPerPage;

export const searchRef = {
    searchResults: $(".searchresults"),
    moreButton: $("#pager-marker"),
    cardContainerClass: CardContainerClass
};

export function apiSearch(limit, offset){
    limit = limit || defaultLimit;
    offset = offset || 0;
    if (typeof CAT_LOCK !== "undefined") {
        filterCategories = CAT_LOCK;
    }
    // if (typeof SKILL_ID !== "undefined") {
    //     filterSkill = SKILL_ID;
    // }
    showSpinner();
    $.ajax({
        method: "POST",
        url: searchEndPoint,
        data: {
            cat: filterCategories,
            tags: [],
            skill: [],
            readStatus: [],
            text: "",
            ord: searchOrder,
            limit: limit,
            offset: offset
        },
        dataType: 'json',
        success: function(data){
            if(!offset) {
                searchRef.searchResults.html(data['html']);
            } else {
                searchRef.searchResults.append(data['html']);
            }
            checkNoCards(searchRef.searchResults);
            showSearchMore(offset);
            hideSearchMore(limit, offset);
            updateCardLazyLoad()
            
            // attach click events to new cards
            // TODO
            // manage different type of cards
            configBookCard()
        },
        error: function(err){
        }
    }).done(function() {
        hideSpinner();
    });

}

function showSearchMore(offset){
    if(!offset){
        searchRef.moreButton.show();
    }
}
function hideSearchMore(requested, previousN){
    const elements = searchRef.searchResults.find(searchRef.cardContainerClass);
    if(elements.length < (previousN + requested)) {
        searchRef.moreButton.hide();
    }
}
